import View from './Wrapper'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const SearchPanel = connect(mapStateToProps)(View)

export default SearchPanel
